import React, { Component } from "react";
import Swal from "sweetalert2";
import Loading from "../../../views/Loading";
import { Grid, Col, Row } from "react-bootstrap";
import Card from "../../../components/Card/Card";
import { dominio } from "../../../routes_backend/routes.jsx";

class FacturasFfacsa extends Component {
  constructor(props) {
    super(props);
    this.state = {
      factura: "",
      motivo: "",
      fechaHoraEncontrada: "",
      now: new Date(),
      isLoading: false,

      lastLookupFactura: "",
      isLookupLoading: false,

      usuarioDB: "",
      plantaDB: "",
      empresaDB: "",
      fechaLlegadaDB: "",

      isExistingRecord: false,
    };
  }

  componentDidMount() {
    this._timer = setInterval(() => {
      this.setState({ now: new Date() });
    }, 1000);
  }

  componentWillUnmount() {
    if (this._timer) clearInterval(this._timer);
  }

  resetForm = () => {
    this.setState({
      factura: "",
      motivo: "",
      fechaHoraEncontrada: "",
      now: new Date(),
      isLoading: false,

      lastLookupFactura: "",
      isLookupLoading: false,

      usuarioDB: "",
      plantaDB: "",
      empresaDB: "",
      fechaLlegadaDB: "",

      isExistingRecord: false,
    });
  };

  // Label "Fecha y Hora (actual)" (solo visual)
  getNowLabel = () => {
    const { now } = this.state;
    try {
      return new Intl.DateTimeFormat("es-ES", {
        dateStyle: "full",
        timeStyle: "medium",
      }).format(now);
    } catch {
      return now.toLocaleString();
    }
  };

  toDatetimeLocalValueWithSeconds = (date) => {
    const d = new Date(date);
    if (isNaN(d.getTime())) return "";
    const pad = (n) => String(n).padStart(2, "0");
    const yyyy = d.getFullYear();
    const mm = pad(d.getMonth() + 1);
    const dd = pad(d.getDate());
    const hh = pad(d.getHours());
    const mi = pad(d.getMinutes());
    const ss = pad(d.getSeconds());
    return `${yyyy}-${mm}-${dd}T${hh}:${mi}:${ss}`;
  };

  toSqlLocalString = (date) => {
    const d = new Date(date);
    if (isNaN(d.getTime())) return null;
    const pad = (n) => String(n).padStart(2, "0");
    const yyyy = d.getFullYear();
    const mm = pad(d.getMonth() + 1);
    const dd = pad(d.getDate());
    const hh = pad(d.getHours());
    const mi = pad(d.getMinutes());
    const ss = pad(d.getSeconds());
    return `${yyyy}-${mm}-${dd} ${hh}:${mi}:${ss}`;
  };

  handleFacturaChange = (e) =>
    this.setState({
      factura: e.target.value,

      isExistingRecord: false,
      lastLookupFactura: "",
      usuarioDB: "",
      plantaDB: "",
      empresaDB: "",
      fechaLlegadaDB: "",

      fechaHoraEncontrada: "",
      motivo: "",
    });

  handleMotivoChange = (e) => this.setState({ motivo: e.target.value });
  handleFechaHoraEncontradaChange = (e) =>
    this.setState({ fechaHoraEncontrada: e.target.value });

  setFechaHoraAhora = () => {
    this.setState({
      fechaHoraEncontrada: this.toDatetimeLocalValueWithSeconds(new Date()),
    });
  };

  buscarFactura = async () => {
    const factura = (this.state.factura || "").trim();
    if (!factura) return;
    if (factura === this.state.lastLookupFactura) return;

    try {
      this.setState({ isLookupLoading: true, lastLookupFactura: factura });

      const response = await fetch(
        `${dominio}/get_FacturasFfacsa/${encodeURIComponent(factura)}`,
        { method: "GET", headers: { "Content-Type": "application/json" } }
      );

      const result = await response.json();

      if (response.ok && result.success && result.data) {
        const data = result.data;

        this.setState({
          isExistingRecord: true,

          motivo: data.motivo || "",

          fechaHoraEncontrada: data.fecha_Encontrada
            ? this.toDatetimeLocalValueWithSeconds(data.fecha_Encontrada)
            : "",

          usuarioDB: data.usuario || "",
          plantaDB: data.planta || "",
          empresaDB: data.empresa || "",
          fechaLlegadaDB: data.fecha_Llegada || "",
        });

        Swal.fire({
          icon: "info",
          title: "Factura encontrada",
          text: "Se cargaron los datos del registro.",
          timer: 1200,
          showConfirmButton: false,
        });
      } else if (response.status === 404) {
        this.setState({
          isExistingRecord: false,
          motivo: "",
          fechaHoraEncontrada: "",
          usuarioDB: "",
          plantaDB: "",
          empresaDB: "",
          fechaLlegadaDB: "",
        });

        Swal.fire(
          "Nuevo registro",
          "No existe registro: se creará uno nuevo.",
          "info"
        );
      } else {
        Swal.fire("Error", result.message || "Error al consultar la factura.", "error");
      }
    } catch (error) {
      Swal.fire(
        "Error",
        `No se pudo conectar con el servidor: ${error.message}`,
        "error"
      );
    } finally {
      this.setState({ isLookupLoading: false });
    }
  };

  handleFacturaBlur = () => this.buscarFactura();

  handleFacturaKeyDown = (e) => {
    if (e.key === "Tab" || e.key === "Enter") this.buscarFactura();
  };

  validar = () => {
    const { factura, motivo, isExistingRecord } = this.state;

    if (!factura || factura.trim() === "") {
      Swal.fire("Error", "Por favor, ingrese el # de Factura Ffacsa.", "error");
      return false;
    }

    if (!isExistingRecord && !motivo) {
      Swal.fire("Error", "Por favor, seleccione un motivo.", "error");
      return false;
    }

    return true;
  };

  handleGuardar = async (e) => {
    e.preventDefault();
    if (!this.validar()) return;

    const {
      factura,
      motivo,
      fechaHoraEncontrada,
      now,
      isExistingRecord,
      fechaLlegadaDB,
    } = this.state;

    let username = "";
    let password = "";
    let codigoUser = "";
    let token = localStorage.getItem("token");
    let token_Data = JSON.parse(token);

    if (token_Data !== null) {
      token_Data.forEach((element) => {
        username = element.usuarioSAP;
        password = element.contraseñaSAP;
        codigoUser = element.U_UserId;
      });
    }

    if (token_Data === null) {
      this.props.history.push("");
      return;
    }

    const fechaEncontradaConSegundos = fechaHoraEncontrada
      ? fechaHoraEncontrada.length === 16
        ? `${fechaHoraEncontrada}:00`
        : fechaHoraEncontrada
      : null;

    const fechaLlegadaParaEnviar = isExistingRecord
      ? fechaLlegadaDB
        ? fechaLlegadaDB
        : null
      : this.toSqlLocalString(now);

    const payload = {
      username,
      password,
      no_Factura: factura.trim(),

      fecha_Llegada: fechaLlegadaParaEnviar,

      motivo,
      fecha_Encontrada: fechaEncontradaConSegundos,

      usuario: codigoUser || username,
      planta: "",
      empresa: "",
    };

    try {
      this.setState({ isLoading: true });

      const response = await fetch(`${dominio}/post_FacturaFfacsa`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (response.ok) {
        Swal.fire("Guardado", result.message || "Registro guardado.", "success");
        this.resetForm();
      } else {
        Swal.fire(
          "Error",
          result.error || result.message || "Ocurrió un error al guardar.",
          "error"
        );
      }
    } catch (error) {
      Swal.fire(
        "Error",
        `No se pudo conectar con el servidor: ${error.message}`,
        "error"
      );
    } finally {
      this.setState({ isLoading: false });
    }
  };

  render() {
    const {
      factura,
      motivo,
      fechaHoraEncontrada,
      isLoading,
      isLookupLoading,
      isExistingRecord,
      fechaLlegadaDB,
    } = this.state;

    const motivos = ["No hay correo.", "No Aparece Factura", "Error de Articulo"];

    const disableFacturaInput = isExistingRecord;
    const disableMotivo = isExistingRecord;

    // ✅ NUEVO: deshabilitar Hora y fecha encontrada cuando NO exista registro
    const disableFechaEncontrada = !isExistingRecord;

    const fechaHoraLabel =
      isExistingRecord && fechaLlegadaDB
        ? (() => {
            try {
              return new Intl.DateTimeFormat("es-ES", {
                dateStyle: "full",
                timeStyle: "medium",
              }).format(new Date(fechaLlegadaDB));
            } catch {
              return String(fechaLlegadaDB);
            }
          })()
        : this.getNowLabel();

    return (
      <div className="content" style={{ textAlign: "center", alignItems: "center" }}>
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title="Registro de Factura"
                ctTableFullWidth
                ctTableResponsive
                content={
                  <div className="content">
                    <style>{`
                      .ffacsa-select { color-scheme: dark; }
                      .ffacsa-select option { background: #0b1220; color: #f8fafc; }
                      .ffacsa-select option:disabled { color: rgba(248, 250, 252, 0.55); }
                      .ffacsa-input::placeholder { color: rgba(255,255,255,0.55); }
                      .ffacsa-input:focus, .ffacsa-select:focus {
                        outline: none;
                        border-color: rgba(96,165,250,0.8);
                        box-shadow: 0 0 0 4px rgba(59,130,246,0.25);
                      }
                    `}</style>

                    <div style={style.centerWrap}>
                      <div style={style.formCard}>
                        <form onSubmit={this.handleGuardar}>
                          <div style={style.field}>
                            <div style={style.label}># Factura Ffacsa</div>
                            <div style={{ position: "relative" }}>
                              <input
                                className="ffacsa-input"
                                type="text"
                                value={factura}
                                onChange={this.handleFacturaChange}
                                onBlur={this.handleFacturaBlur}
                                onKeyDown={this.handleFacturaKeyDown}
                                placeholder="Ej. FF-000123"
                                style={{
                                  ...style.input,
                                  ...(disableFacturaInput ? style.disabledControl : {}),
                                }}
                                disabled={disableFacturaInput}
                              />
                              {isLookupLoading ? (
                                <div style={style.lookupBadge}>Buscando…</div>
                              ) : null}
                            </div>
                          </div>

                          <div style={style.field}>
                            <div style={style.label}>
                              Fecha y Hora {isExistingRecord ? "(guardada)" : "(actual)"}
                            </div>
                            <div style={style.readonlyBox}>{fechaHoraLabel}</div>
                          </div>

                          <div style={style.field}>
                            <div style={style.label}>Motivo</div>
                            <select
                              className="ffacsa-select"
                              value={motivo}
                              onChange={this.handleMotivoChange}
                              style={{
                                ...style.select,
                                ...(disableMotivo ? style.disabledControl : {}),
                              }}
                              disabled={disableMotivo}
                            >
                              <option value="" disabled>
                                Selecciona un motivo...
                              </option>
                              {motivos.map((m) => (
                                <option key={m} value={m}>
                                  {m}
                                </option>
                              ))}
                            </select>
                          </div>

                          {/* ✅ CAMBIO: Hora y fecha encontrada se deshabilita si NO existe registro */}
                          <div style={style.field}>
                            <div style={style.label}>Hora y fecha encontrada</div>

                            <div style={style.dateWrap}>
                              <input
                                className="ffacsa-input"
                                type="datetime-local"
                                step="1"
                                value={fechaHoraEncontrada}
                                onChange={this.handleFechaHoraEncontradaChange}
                                style={{
                                  ...style.inputDateWithButton,
                                  ...(disableFechaEncontrada ? style.disabledControl : {}),
                                }}
                                disabled={disableFechaEncontrada}
                              />
                              <button
                                type="button"
                                onClick={this.setFechaHoraAhora}
                                title="Colocar fecha y hora actual"
                                style={{
                                  ...style.nowButton,
                                  ...(disableFechaEncontrada ? style.disabledControl : {}),
                                }}
                                disabled={disableFechaEncontrada}
                              >
                                Ahora
                              </button>
                            </div>

                            <div style={style.helper}>
                              {isExistingRecord
                                ? "Se cargó la fecha/hora encontrada del registro. Puedes modificarla o usar Ahora."
                                : "Este campo se habilita únicamente cuando la factura ya existe en el sistema."}
                            </div>
                          </div>

                          <button type="submit" style={style.button}>
                            Guardar
                          </button>
                        </form>
                      </div>
                    </div>
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>

        {isLoading && <Loading />}
      </div>
    );
  }
}

const style = {
  centerWrap: {
    minHeight: "65vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "16px",
  },
  formCard: {
    width: "100%",
    maxWidth: "560px",
    borderRadius: "14px",
    padding: "18px",
    backgroundColor: "#0b1220",
    border: "1px solid rgba(255,255,255,0.10)",
    boxShadow: "0 18px 50px rgba(0,0,0,0.18)",
    textAlign: "left",
  },
  field: { marginBottom: "14px" },
  label: {
    fontWeight: "700",
    fontSize: "13px",
    marginBottom: "8px",
    color: "rgba(248,250,252,0.95)",
  },
  input: {
    width: "100%",
    padding: "12px",
    borderRadius: "10px",
    border: "1px solid rgba(255,255,255,0.16)",
    backgroundColor: "rgba(255,255,255,0.06)",
    color: "#F8FAFC",
    fontSize: "14px",
  },
  lookupBadge: {
    position: "absolute",
    right: "10px",
    top: "50%",
    transform: "translateY(-50%)",
    fontSize: "12px",
    color: "rgba(226,232,240,0.85)",
  },
  select: {
    width: "100%",
    padding: "12px",
    borderRadius: "10px",
    border: "1px solid rgba(255,255,255,0.16)",
    backgroundColor: "rgba(255,255,255,0.06)",
    color: "#F8FAFC",
    fontSize: "14px",
    colorScheme: "dark",
  },
  readonlyBox: {
    width: "100%",
    padding: "12px",
    borderRadius: "10px",
    border: "1px dashed rgba(255,255,255,0.22)",
    backgroundColor: "rgba(255,255,255,0.04)",
    color: "rgba(248,250,252,0.95)",
    fontSize: "14px",
  },
  helper: {
    marginTop: "8px",
    fontSize: "12px",
    color: "rgba(226,232,240,0.78)",
  },
  dateWrap: { position: "relative", width: "100%" },
  inputDateWithButton: {
    width: "100%",
    padding: "12px",
    paddingRight: "84px",
    borderRadius: "10px",
    border: "1px solid rgba(255,255,255,0.16)",
    backgroundColor: "rgba(255,255,255,0.06)",
    color: "#F8FAFC",
    fontSize: "14px",
  },
  nowButton: {
    position: "absolute",
    right: "10px",
    top: "50%",
    transform: "translateY(-50%)",
    height: "34px",
    padding: "0 12px",
    borderRadius: "8px",
    border: "1px solid rgba(255,255,255,0.16)",
    background: "rgba(255,255,255,0.10)",
    color: "#F8FAFC",
    fontWeight: "800",
    fontSize: "12px",
    cursor: "pointer",
  },
  disabledControl: {
    opacity: 0.6,
    cursor: "not-allowed",
  },
  button: {
    width: "100%",
    padding: "12px 14px",
    borderRadius: "10px",
    border: "1px solid rgba(255,255,255,0.14)",
    background:
      "linear-gradient(90deg, rgba(37,99,235,0.95), rgba(59,130,246,0.90))",
    color: "#04102a",
    fontWeight: "900",
    cursor: "pointer",
  },
};

export default FacturasFfacsa;
